import React from "react";
import { chefInfo, servicesList } from "../mock";
import { Check } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="bg-[#fbf3e4] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-4xl">
          <p className="text-xs tracking-[0.4em] text-neutral-500 mb-4">ABOUT ME</p>
          <h3 className="font-display text-4xl md:text-5xl leading-tight text-neutral-900">
            {chefInfo.location}
          </h3>
          <p className="mt-8 text-neutral-800 text-lg leading-relaxed max-w-3xl">
            {chefInfo.intro}
          </p>
          <p className="mt-6 text-neutral-700 text-base leading-relaxed max-w-3xl">
            {chefInfo.availability}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="text-xs tracking-[0.4em] text-neutral-500 mb-4">MY SERVICES</p>
            <h4 className="font-display text-3xl md:text-4xl text-neutral-900 mb-6">
              What I offer
            </h4>
            <p className="text-neutral-700 mb-6">
              I offer a range of services including the below. For more details please see the section further down.
            </p>
            <ul className="space-y-3">
              {servicesList.map((s) => (
                <li key={s} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-neutral-900 text-[#fbf3e4] flex items-center justify-center flex-shrink-0">
                    <Check size={12} />
                  </span>
                  <span className="text-neutral-800">{s}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src={chefInfo.photo}
                alt={chefInfo.name}
                className="w-full h-full object-cover hero-image-shadow"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-neutral-900 text-[#fbf3e4] px-6 py-4 hidden md:block">
              <div className="font-display text-2xl leading-none">Chef Mete</div>
              <div className="text-xs tracking-[0.3em] mt-1 text-neutral-300">PRIVATE CHEF</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
